import React from 'react';
import _ from 'lodash';

import { useCheckout } from 'checkout/context';
import useStores from 'shared/hooks/use-stores';
import useDispensaryFlag from 'shared/hooks/use-dispensary-flag';
import { CheckoutVariants } from 'src/constants/checkout-variants';

import { OAuthLogin } from '../oauth-login';
import { InternalLogin } from '../internal-login';

export function AccountSection(): JSX.Element {
  const { Cart } = useStores();
  const { variant } = useCheckout();
  const isIsolatedCheckout = variant === CheckoutVariants.isolatedCheckout;
  const dispensaryId = _.get(Cart, `order.dispensary.id`, '');
  const isExternalProviderEnabled = useDispensaryFlag(
    `growth.ecomm.dutchie-plus-external-auth-provider-checkout.rollout`,
    dispensaryId
  );
  const enableOmniauthLogin = Cart.dispensary.storeSettings?.enableOmniauthLoginCheckout ?? false;

  return isIsolatedCheckout && (isExternalProviderEnabled || enableOmniauthLogin) ? <OAuthLogin /> : <InternalLogin />;
}
